module.exports = __webpack_public_path__ + "img/paishui2.994fe492.png";